<div class="tenants-activation-container">

    <!-- Nested view  -->
    <router-outlet></router-outlet>

</div>
